import { createContext, useContext } from "react";
import { LayerTypeProviderProps } from "../../../types";
import { PermitState, PermitStateDispatch, usePermitFilterState } from "../state/usePermitFilterState";

interface PermitsContextProps {
  state: PermitState;
  stateDispatch: PermitStateDispatch;
}

const PermitsContext = createContext({} as PermitsContextProps);

export const usePermitsContext = () => useContext(PermitsContext);

export function PermitsLayerProvider({ children }: LayerTypeProviderProps) {
  const [state, stateDispatch] = usePermitFilterState();

  return (
    <PermitsContext.Provider
      value={{
        state,
        stateDispatch,
      }}
    >
      {children}
    </PermitsContext.Provider>
  );
}
